<template>
    <div>
      <el-tabs
          v-if="tabList.length > 0"
          v-model="activeName"
          @tab-click="handleChannelTypeChange">
        <el-tab-pane
          v-for="(item,index) in tabList"
          :key="index"
          :label="item.bankName"
          :name="item.bankName">
          <div :key="bankChannelType">
            <slot :channelType="item.bankCode"></slot>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-empty
        v-else
        v-loading="loading"
        element-loading-text="拼命加载中"
        description="获取列表失败">
      </el-empty>
    </div>
    </template>
<script>
import { head } from 'lodash'
import { getWithholdingBankType } from '@/api/domain/finance'
import { mapGetters } from 'vuex'

export default {
  props: {
    bankType: {
      type: Number,
      default: 0,
    },
    // todo 资金划扣配置/交易明细对账单暂时保留平安银行tab，之后会删除
    hasPingan: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tabList: [],
      activeName: '',
      loading: true,
    }
  },
  methods: {
    async getBankTypeList() {
      try {
        const params = {}
        if (this.bankType) {
          params.accountType = 2 // 2是维保，3是代扣
        }
        const { code, data } = await getWithholdingBankType(params)
        if (code === 1 && Array.isArray(data) && data.length > 0) {
          this.loading = false
          this.tabList = data
          const firstData = head(data)
          this.activeName = firstData.bankName
          this.$store.commit('SET_BANK_CHANNEL_TYPE', firstData.bankCode)
          this.$store.commit('SET_BANK_CHANNEL_NAME', firstData.bankName)
          this.$emit('getChannelType', firstData.bankCode)
        } else {
          this.loading = false
        }
      } catch (error) {
        this.loading = false
      }
    },
    // todo tab先前端默认为网商银行，待服务端修改后再调用服务端接口
    getWangshangBankType() {
      this.tabList = [{
        bankName: '网商银行',
        bankCode: 8,
      }]
      const firstData = head(this.tabList)
      this.activeName = firstData.bankName
      this.$store.commit('SET_BANK_CHANNEL_TYPE', firstData.bankCode)
      this.$store.commit('SET_BANK_CHANNEL_NAME', firstData.bankName)
      this.$emit('getChannelType', firstData.bankCode)
    },
    handleChannelTypeChange(tab) {
      const { bankCode, bankName } = this.tabList[tab.index]
      this.$store.commit('SET_BANK_CHANNEL_TYPE', bankCode)
      this.$store.commit('SET_BANK_CHANNEL_NAME', bankName)
      this.$emit('getChannelType', this.tabList[tab.index].bankCode)
    },
  },
  computed: {
    ...mapGetters(['bankChannelType']),
  },
  created() {
    if (this.hasPingan) {
      this.getBankTypeList()
    } else {
      this.getWangshangBankType()
    }
  },
}
</script>
